import ChannelContext from '@jetshop/core/components/ChannelContext';
import ProductConfigurationContext from '@jetshop/core/components/ProductConfigurationProvider/ProductConfigurationContext';
import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import t, { Intl, useIntl } from '@jetshop/intl';
import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import getParentOrCanonicalRoute from '@jetshop/ui/Breadcrumbs/getParentsOrCanonicalRoute';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import { Form, useField } from 'formik';
import get from 'lodash.get';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import { Helmet } from 'react-helmet-async';
import MaxWidth from '../Layout/MaxWidth';
import { Price } from '../Price';
import Button from '../ui/Button';
import InputWithLabel from '../Forms/Input';
import AddToCartForm from './AddToCart/AddToCartForm';
// import Campaigns from './Campaigns';
import ImageContainer from './Images/ImageContainer';
import ProductInfoAccordion from './ProductInfoAccordion';
import ProductPageLoadingState from './ProductPageLoadingState';
import { RelatedProducts } from './RelatedProducts';
import NotifyWhenBack from './StockStatus/NotifyWhenBack';
import { Container } from './styledComponents';
import Favorites from '../StartPage/Content/Favorites';
import BrandLogo from '../Brand/BrandLogo';
import QuantityInput from '../Forms/QuantityInput';
import { useQuery } from 'react-apollo';
import { BrandLinkQuery } from './BrandLinkQuery.gql';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ProductColorQuery from './ProductColorsQuery.gql';
import Image from '@jetshop/ui/Image/Image';
import { AddFavourite } from '../ProductList/AddFavourite';
import { VoyadoTracking } from '../MyPages/VoyadoTracking';
import { usePriceDiffer } from './usePriceDiffer';
import { useVariantFromUrl } from '@jetshop/core/hooks/useProductVariants/useVariantFromUrl';
import { VariantSelector } from './SizePicker';
import { PriceHistory } from './PriceHistory';
import { theme } from '../Theme';
import { cleanTextString } from '../CategoryPage/CategoryHeader';
import {
  parsePosition,
  getMatchingTemplates
} from '../CategoryPage/ProductCard';
import { useGlobalSettings } from '../Settings/GlobalSettings';
import { useCart } from '@jetshop/core/components/Query/CartProvider';
import cartQuery from '../Cart/CartQuery.gql';
import useSortSizes from './useSortSizes';
import { DynamicCategoryRenderer } from '../StartPage/ContentRendererComponents/DynamicCategoryRenderer/DynamicCategoryRenderer';
import { productPageComponents } from '../StartPage/ContentRendererComponents/allcomponents';
import useVisibilitySettings from '../../utils/useVisibilitySettings';
import ProductsArrayQuery from '../ProductsArrayQuery.gql';
import ProductCarousel from '../ui/ProductCarousel';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import { useProductPricing } from '../../utils/useProductPricing';
import { useVariantPricing } from '../../utils/useVariantPricing';
import {
  PriceWrapper,
  RefinedProductCard,
  removeBrandFromProductName
} from '../CategoryPage/RefinedProductCard';
import { cx, css } from 'linaria';
import { GmfProductRating } from '../CategoryPage/GmfProductRating';
import { StoreStock } from './StockStatus/StoreStock';
import { useFavoriteStore } from '../../contexts/FavoriteStoreContext';
import { getPercentage } from '../../utils/getPercentage';
import { useTracking } from '../../utils/tracking/useTracking';
import { PAGE_TYPES } from '../../utils/tracking/constants';
import { useElevate } from '../Elevate/ElevateContext';
import { ElevateRecommendationsHandler } from '../Elevate/pdp/ElevateRecommendationsHandler';
import { ElevateVariants } from '../Elevate/ElevateVariants';
import { GmfProductSummary } from './GmfProductSummary';
import { ElevateAddToCartPopup } from '../Elevate/ElevateAddToCartPopup';

const pdpProductTitleStyle = css`
  margin: 0;
  .product-name {
    display: block;
    font-weight: 500;
    font-size: 14px !important;
    overflow: hidden;
    text-align: left !important;
    text-transform: uppercase;
    color: ${theme.colors.primary};
    margin: 0 !important;
    letter-spacing: 0.02em !important;
  }
  .brand-name,
  .product-variation {
    display: block;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-transform: uppercase;
    line-height: 1.2;
    text-align: left;
    -webkit-letter-spacing: 0.06em;
    -moz-letter-spacing: 0.06em;
    -ms-letter-spacing: 0.06em;
    letter-spacing: 0.06em;
    margin-top: 6px;
  }
  .brand-name {
    line-height: 1.15;
  }
`;

const ProductUpper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4rem;
  ${theme.below.lg} {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
`;
const ProductLeft = styled('div')`
  width: 65%;
  margin-right: 1rem;
  position: relative;
  & > div:first-of-type {
    ${theme.below.sm} {
      right: 10px !important;
      position: absolute;
      z-index: 2;
    }
  }
  & > h2 {
    ${theme.below.lg} {
      padding-top: 10px !important;
      margin-top: 10px !important;
    }
  }
  .favorite-icon {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
    ${theme.below.sm} {
      right: 10px;
      top: 10px;
    }
  }
  ${theme.below.lg} {
    margin: auto;
  }
  ${theme.below.md} {
    width: 100%;
    padding: 0;
    margin-right: 10px;
    margin-left: 10px;
  }

  .image-gallery-image {
    & > div {
    }
  }
`;
const ProductRight = styled('div')`
  width: 35%;
  height: 100%;
  padding: 1rem;
  padding-right: 2rem;
  padding-top: 4px;

  ${theme.below.lg} {
    width: 100%;
    padding: 1rem;
    padding-bottom: 0rem;
    height: auto;
  }
  ${theme.below.sm} {
    padding: 1rem 10px;
  }

  .stock-contact-info {
    font-size: 11px;
    width: 100%;
    ${theme.below.sm} {
      padding-left: 10px;
    }
    a {
      color: #000;
      font-weight: bold;
      text-decoration: none;
    }
  }
`;

const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const QuantityAddToCartWrapper = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-start;
  margin-top: 0.3rem;
  label {
    display: none;
  }
  .quantity-input-wrapper input[type='number'] {
    border-radius: 0;
    height: 42px;
    background: #fff;
  }
`;

const ProductContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
  ${theme.below.lg} {
    margin-bottom: 4rem;
  }

  .product-breadcrumbs {
    ${theme.below.lg} {
      padding: 1rem 0.5rem;
    }
    ${theme.below.sm} {
      padding: 0 10px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    li {
      color: #000;
      /* font-size: 11px; */
      /* &:last-of-type {
        font-weight: bold;
      } */
      a {
        color: #000;
        /* text-decoration: none;
        font-size: 11px; */
      }
    }
  }

  ${theme.below.lg} {
    padding: 0;
    > div {
      padding: 0;
    }
  }

  header {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .left {
      width: 60%;
      flex-grow: 1;

      a {
        text-decoration: none;
      }
    }

    .right {
      width: 70px;
      flex-shrink: 0;
      .brand-logo {
        width: 70px !important;
        height: 60px !important;
      }
    }

    margin-bottom: 0;
  }
  .price-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .old-price {
      margin-bottom: 0;
    }

    .old-price.fr .fr {
      margin-bottom: 0;
    }

    .reverse-order {
      gap: 8px;
    }

    ${theme.below.md} {
      .member-price,
      .price,
      .old-price {
        --price-font-size: 2.5rem;
        --currency-font-size: 0.8rem;
        --price-font-weight: 600;
      }
    }
  }

  .customer-comment-input-wrapper {
    .customer-comment-input {
      height: 44px;
    }
    .status-wrapper {
      top: -39px;
    }
  }
  .quantity-input-wrapper {
    margin-bottom: 0rem;
    margin-right: 0.7rem;
    width: 160px;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type='number'] {
      -moz-appearance: textfield; /* Firefox */
    }
    input {
      width: 44px;
      height: 54px;
      text-align: center;
      padding: 0px;
      margin-bottom: 0px;
    }
    label {
      text-align: center;
    }
  }
  .campaign-name {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 0.5rem;
    /* margin-top: -2.2rem; */
    color: ${theme.colors.accent};
    text-transform: uppercase;
    ${theme.below.md} {
      margin-top: 0;
    }
  }
  .symbol-description {
    font-size: 14px;
    line-height: 1.2;
    color: #000;
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
  }
  .short-description {
    line-height: 1.5;
    font-size: 14px;
    margin-bottom: 24px;
    font-family: 'Times New Roman', serif;
    letter-spacing: 0.25px;
    ${theme.below.lg} {
      margin-bottom: 0;
    }
    p {
      margin-bottom: 1rem;
    }
  }
  .delivery-list {
    li {
      display: flex;
      align-items: center;
      svg {
        margin-right: 16px;
      }
      margin-bottom: 16px;
    }
  }
  .product-details {
  }
`;

const BuyButton = styled(Button)`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.accent};
  border: 2px solid ${theme.colors.accent};
  letter-spacing: 0.05em;
  display: flex;
  justify-content: center;
  text-align: center;
  text-decoration: none !important;
  text-transform: uppercase;
  width: 100%;
  font-weight: bold;
  font-size: 13px;
  padding: 0;
  color: white;
  height: 42px;
  line-height: 1.2;
  margin-bottom: 20px;
  &:hover {
    background-color: transparent;
    color: ${theme.colors.accent};
    border-color: ${theme.colors.accent};
  }
  /* &:focus {
    outline: none;
  } */
  &.disabled {
    opacity: 0.8;
    cursor: not-allowed;
    pointer-events: none;
    filter: grayscale(1);
  }
  span {
    font-weight: 400;
    font-size: 11px;
    text-transform: none;
  }
`;

const MaxReachedMessage = styled('p')`
  position: absolute;
  margin-top: 2.77rem;
  font-size: 12px;
  color: ${theme.colors.orange};
  ${theme.below.md} {
    font-size: 14px;
  }
`;

const Names = styled('div')`
  max-width: 100%;

  h2 {
    margin-top: 6px;
  }
`;

const OtherColors = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  div {
    margin: 0.5rem;
    width: 75px;
    height: 75px;
  }
  ${theme.below.lg} {
    margin-bottom: 1rem;
  }
`;

const StoreDeliveryFlex = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  &.single {
    justify-content: flex-end;
  }

  &.double {
    flex-direction: column-reverse;
    .delivery-information {
      margin-top: 8px;
      padding-left: 8px;
    }
  }
`;

const Checkmark = styled('div')`
  transform: rotate(45deg);
  height: 11px;
  width: 6px;
  border-bottom: 2px solid #4cd038;
  border-right: 2px solid #4cd038;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
`;

const Cross = styled('div')`
  position: relative;
  width: 0px;
  height: 8px;
  margin-right: 8px;
  margin-top: 4px;
  flex-shrink: 0;

  :before,
  :after {
    position: absolute;
    left: 0px;
    content: ' ';
    height: 10px;
    width: 2px;
    background-color: #b13827;
  }
  :before {
    transform: rotate(45deg);
  }
  :after {
    transform: rotate(-45deg);
  }
`;

const DeliveryInformation = styled('div')`
  font-size: 12px;
  margin-top: -1px;
  color: #000;
  display: flex;
  align-items: baseline;
  ${theme.below.md} {
    font-size: 14px;
    width: 100%;
  }
`;

export const breadcrumWrapperStyles = css`
  flex-direction: row;
  justify-content: flex-start;
  ul {
    flex-direction: row;

    li {
      color: #000;
      font-size: 14px !important;
      font-weight: 700;
      line-height: 1.3;
      text-decoration: none;
      a {
        font-size: inherit;
        color: inherit;
        text-decoration: underline;
      }

      &::after {
        font-weight: 400 !important;
      }
    }
    li:last-of-type::after {
      content: none !important;
    }
  }
`;

export const BreadcrumbsMaxWidth = styled(MaxWidth)``;
const ArticleNumber = styled('span')`
  display: block;
  font-size: 12px;
  line-height: 1;
  color: black;
  font-weight: 400;
  width: fit-content;
  margin-bottom: 26px;
`;

export const ProductSymbolWrapper = styled('div')`
  position: absolute;
  width: calc(${props => props.symbolSize});
  height: calc(${props => props.symbolSize});
  z-index: 2;
  margin: 0.2rem;
  ${theme.below.sm} {
    width: calc(${props => props.symbolSizeMobile});
    height: calc(${props => props.symbolSizetMobile});
  }
  .product-symbol {
    padding-bottom: 0 !important;
    height: calc(${props => props.symbolSize}) !important;
    ${theme.below.sm} {
      height: calc(${props => props.symbolSizeMobile}) !important;
    }
    display: content;
    picture {
      display: content;
    }
    img {
      padding: 0px !important;
      max-width: 100% !important;
      max-height: 100% !important;
      width: auto !important;
      height: auto !important;
      position: absolute !important;
    }
  }
`;

const TitleWrapper = styled('div')`
  text-align: left;
  margin: 2rem 0 0.5rem 0;
  ${theme.below.md} {
    text-align: left;
    margin: 1rem 0 0.5rem 0.5rem;
  }
`;

const ProductGridWrapper = styled('ul')`
  display: grid;
  grid-template-columns: repeat(${props => props.productsLength}, 1fr);
  gap: 1rem;
  max-width: 94rem;
  width: 100%;
  margin: auto;
  padding: 1rem 2rem;
  list-style: none;
`;

export const getBrand = product => {
  const field = product?.customFields?.find(({ key }) => key === 'Brand');
  if (field) {
    return field?.stringValue || field?.value;
  } else {
    const backupBrand = product?.customFields?.find(
      ({ key }) => key === 'ProductBrand'
    );
    return backupBrand?.stringValue || backupBrand?.value || '';
  }
};

function getYoutube(product) {
  const field = product?.customFields?.find(({ key }) => key === 'VideoDomain');
  if (field) {
    return { id: 'youtube', value: field.stringValue };
  }
}
function getMaterial(product) {
  const field = product?.customFields?.find(({ key }) => key === 'Material');
  if (field) {
    return { title: field.title, value: field.stringValue };
  }
}
function getMaterialInfo(product) {
  const field = product?.customFields?.find(
    ({ key }) => key === 'TextresourceTypeInfoMaterial'
  );
  if (field) {
    return { title: field.title, value: field.htmlValue };
  }
}
function getGoodToKnow(product) {
  const field = product?.customFields?.find(
    ({ key }) => key === 'TextresourceTypeGoodToKnow'
  );
  if (field) {
    return { title: field.title, value: field.htmlValue };
  }
}

/* Återimplementerat från äldre kodbas */

function getWarningInfo(product) {
  const field = product.customFields.find(
    ({ key }) => key === 'TextresourceTypeWarning'
  );
  if (field) {
    return { title: field.title, value: field.htmlValue };
  }
}
function getImportantInfoHeadline(product) {
  const field = product.customFields.find(
    ({ key }) => key === 'TextresourceTypeImportantHeadline'
  );
  if (field) {
    return { title: field.title, value: field.htmlValue };
  }
}
function getImportantInfo(product) {
  const field = product.customFields.find(
    ({ key }) => key === 'TextresourceTypeImportant'
  );
  if (field) {
    return { title: field.title, value: field.htmlValue };
  }
}

const ProductMeta = ({ product, selectedVariation }) => {
  const { selectedChannel } = useContext(ChannelContext);

  const prod = selectedVariation || product;
  const brand = getBrand(product);

  return (
    <Helmet>
      <meta property="og:title" content={product.name} />
      <meta
        property="product:original_price:amount"
        content={prod?.price?.incVat}
      />
      <meta
        property="product:price:amount"
        content={prod?.previousPrice?.incVat}
      />
      <meta
        property="og:price:currency"
        content={selectedChannel.currency.id}
      />
      {product.images.length > 0 && (
        <meta property="og:image" content={product.images[0].url} />
      )}
      <meta
        property="product:availability"
        content={prod.stockStatus.buyable ? 'instock' : 'oos'}
      />
      {brand && <meta property="product:brand" content={brand} />}
      <meta
        property="product:category"
        content={product.canonicalCategory && product.canonicalCategory.name}
      />
      <meta
        property="og:url"
        content={`${selectedChannel.url}${product?.primaryRoute?.path}`}
      />
    </Helmet>
  );
};

const useOtherColors = artno => {
  const term = artno ? artno.split('-')[0] : null;
  const artNoLength = artno ? artno.split('-').length : 0;
  const { data, loading } = useQuery(ProductColorQuery, {
    variables: { term },
    skip: !term
  });
  return { colorData: data, colorLoading: loading, artNoLength };
};

function BuyTheStyle({ products }) {
  if (products?.length === 0 || products === undefined) return null;
  return (
    <>
      <TitleWrapper>
        <h2>{t('Style with')}</h2>
      </TitleWrapper>
      <Above breakpoint="lg">
        {matches =>
          matches ? (
            <ProductGridWrapper productsLength={products?.length}>
              {products?.map((product, index) => (
                <RefinedProductCard key={index} product={product} />
              ))}
            </ProductGridWrapper>
          ) : (
            <ProductCarousel
              products={products}
              ProductComponent={props => (
                <RefinedProductCard {...props} as="div" />
              )}
            />
          )
        }
      </Above>
    </>
  );
}

const MaxQtyComment = ({ maxQty, setValues, alreadyInCart }) => {
  const [helpers] = useField('comments');
  const maxReached = alreadyInCart >= maxQty;
  useEffect(() => {
    if (maxQty) {
      helpers.setValue({ max: maxQty.toString() });
    }
  }, [maxQty, setValues]); // eslint-disable-line react-hooks/exhaustive-deps

  if (maxReached) {
    return (
      <MaxReachedMessage>{t('Max quantity reached in cart')}</MaxReachedMessage>
    );
  }
  return null;
};

export const isSaleProduct = product => {
  const hasKey =
    product?.customFields
      ?.find(v => v.key === 'MarketingCategory')
      ?.listValues?.includes('S4L3-PR0DUC75') ?? false;
  const loweredPrice = product?.price?.incVat < product?.previousPrice?.incVat;
  return hasKey && loweredPrice;
};

const CAMPAIGN_COLORS = {
  rosa: theme.colors.pink,
  grön: theme.colors.accent,
  röd: theme.colors.christmasred,
  svart: theme.colors.black
};

export const getArtNoPartial = artNo => {
  const sections = artNo?.split('-');
  const filteredSections = sections?.filter(section => section !== '00000');
  return filteredSections?.join('-');
};

const elvateVariantsPDPStyle = css`
  margin-top: 10px;
  margin-left: 0px;
  &.elevate-variants-wrapper {
    gap: 10px;

    ${theme.below.md} {
      gap: 12px;
    }
    button {
      height: 32px;
      width: 32px;
    }
  }
`;

const Product = ({ result: { data, loading }, product }) => {
  const { trackViewItem, trackPageView } = useTracking();
  const initialVariant = useVariantFromUrl();
  const { selectedChannel } = useContext(ChannelContext);
  const history = useHistory();
  const location = useLocation();
  const isSale = isSaleProduct(product);
  const { cart } = useCart(cartQuery);
  const { loggedIn } = useAuth();
  const { favoriteStore } = useFavoriteStore();
  const {
    getProductPageData,
    getElevateProductByKeyFromProductGroup,
    notification,
    NOTIFICATION_TYPES
  } = useElevate();
  const [elevateProductPageData, setElevateProductPageData] = useState(null);
  const [showCurtain, setShowCurtain] = useState(false);

  //MEMBER PRICE
  const hasMemberPrice = product?.hasMemberPrice;
  const productToUse = useProductPricing(product, hasMemberPrice, loggedIn);

  // GET CHOSEN PRODUCTS FROM CUSTOM FIELD - BUY THE STYLE
  const chosenProductsArtNos =
    product?.customFields?.find(field => field?.key === 'PDPproductRow')
      ?.listValues ?? [];

  const chosenProductsData = useQuery(ProductsArrayQuery, {
    variables: {
      articleNumbers: chosenProductsArtNos
    },
    errorPolicy: 'all',
    skip: !chosenProductsArtNos
  });
  const chosenProducts = chosenProductsData?.data?.products;

  // GET PRODUCT TEMPLATE
  const { productTemplates, saleTemplate } = useGlobalSettings();
  const templates = getMatchingTemplates(product, productTemplates);
  const hasSaleTemplate = Object.keys(saleTemplate).length > 0;
  const productTemplate = productTemplates[templates?.[0]] ?? null;

  //SYMBOL FROM PRODUCT TEMPLATE VISIBILITY
  const countryVisibilitySettings = {
    sweden: productTemplate?.sweden,
    denmark: productTemplate?.denmark,
    norway: productTemplate?.norway,
    finland: productTemplate?.finland,
    netherlands: productTemplate?.netherlands,
    eu: productTemplate?.eu,
    loggedIn: productTemplate?.loggedIn,
    loggedOut: productTemplate?.loggedOut
  };
  const doNotRender = useVisibilitySettings(countryVisibilitySettings);

  const shouldSkipGmfCommentSection = (() => {
    try {
      return new URLSearchParams(location?.search ?? '').has(
        'gmf-comment-section-skip'
      );
    } catch (e) {
      return false;
    }
  })();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getProductPageData({
        productKey: product?.articleNumber
      });
      setElevateProductPageData(response);
    };
    if (product) {
      fetchData();
    }
  }, [product]);

  // Remove canonical links from the document head when the GMF comment section should be skipped.
  useEffect(() => {
    if (!shouldSkipGmfCommentSection) return;

    // Function to remove existing canonical links.
    const removeCanonicalLinks = () => {
      const canonicalLinks = document.querySelectorAll(
        'link[rel="canonical"], link[rel="Canonical"]'
      );
      canonicalLinks.forEach(link => link.remove());
    };

    // Remove immediately in case canonical is already present.
    removeCanonicalLinks();

    // Create a MutationObserver to remove canonical links if injected later.
    const observer = new MutationObserver(removeCanonicalLinks);
    observer.observe(document.head, { childList: true, subtree: true });

    // Clean up the observer when effect is disposed.
    return () => {
      observer.disconnect();
    };
  }, [shouldSkipGmfCommentSection]);

  useEffect(() => {
    const structuredDataScript = document.querySelector(
      'script[type="application/ld+json"]'
    );
    if (structuredDataScript) {
      // Parse the existing JSON data
      try {
        const jsonData = JSON.parse(structuredDataScript.textContent);
        // Add the "@id" field to the JSON object
        jsonData['@id'] = '#product';
        // Update the script's content with the modified JSON data
        structuredDataScript.textContent = JSON.stringify(jsonData, null, 2); // pretty-print the JSON for readability
      } catch (e) {}
    } else {
    }
  }, [product]);

  let alreadyInCart = useMemo(() => {
    const prodVariants =
      product?.variants?.values?.map(variant => {
        return variant.articleNumber;
      }) ?? [];

    if (cart?.items) {
      const item = cart?.items?.filter(item => {
        if (prodVariants.includes(item.articleNumber)) {
          return true;
        }
        return item?.articleNumber === product?.articleNumber;
      });
      const total = item.reduce((acc, item) => {
        return acc + item.quantity;
      }, 0);
      return total;
    }
    return 0;
  }, [cart?.items]);

  // SORT SIZES & SET VARIANT HANDLER
  const sortedSizesProduct = useSortSizes(product);
  const variantHandler = useProductVariants(sortedSizesProduct, {
    initialVariant
  });
  const { selectedVariant: selectedVariation } = variantHandler;
  const selectedVariationToUse = useVariantPricing(
    selectedVariation,
    hasMemberPrice,
    loggedIn
  );

  // CONFIGURATION CONTEXT
  const configurationContext = useContext(ProductConfigurationContext);

  // STOCK STATUS
  const stockStatus = useStockStatus(selectedVariation || product);

  // PRICE DIFFERENCE
  const hasPriceDiffer = usePriceDiffer({
    variants: product?.variants?.values
  });

  // OTHER COLORS
  const { colorData } = useOtherColors(product?.articleNumber);

  function useBrandInfo(brand, returnId = false) {
    const { loading, error, data } = useQuery(BrandLinkQuery, {});

    if (loading) {
      return null;
    }
    if (error) {
      return `Error!: ${error}`;
    }
    if (data?.category && data?.category?.subcategories) {
      const subCat = data?.category?.subcategories?.filter(
        subCat => subCat.name === brand
      );
      if (returnId) {
        return subCat[0]?.id;
      }
      if (subCat?.length > 0) {
        return subCat[0]?.primaryRoute?.path;
      }
    }
    return null;
  }

  // Get brand then get brand id then get supplier info (if any in custom field)
  const brand = getBrand(product);
  const brandId = useBrandInfo(brand, true);
  const productArtNo = product?.articleNumber;
  const manufacturer = {
    name: brand,
    id: brandId,
    productArtNo: productArtNo
  };

  function getArtNoPartial(artNo) {
    if (!artNo) return '';
    const sections = artNo.split('-');
    const filteredSections = sections.filter(section => section !== '00000');
    return filteredSections.join('-');
  }

  const BrandLink = ({ brandLink }) => {
    const link = useBrandInfo(brandLink);
    if (!link) return null;
    return (
      <Link to={link}>
        <BrandLogo brandName={getBrand(product)} />
      </Link>
    );
  };

  const parents = getParentOrCanonicalRoute(
    get(data, 'route.parents'),
    product
  );

  const categoryBreadcrumbs = [...(parents || [])]
    .reverse()
    .map(parent => cleanTextString(parent?.object?.breadcrumbText))
    .filter(Boolean);

  //SYMBOL FROM PRODUCT TEMPLATE SIZE
  const desktopScale = parseInt(productTemplate?.symbolDesktopSize) / 100 ?? 2;
  const mobileScale = parseInt(productTemplate?.symbolMobileSize) / 100 ?? 1.5;

  const desktopSize = (productTemplate?.symbolSize ?? 0) * desktopScale;
  const mobileSize = productTemplate?.symbolSize * mobileScale;

  const hasHeight = productTemplate?.symbolHeight !== null;
  const height = productTemplate?.symbolHeight * desktopScale;
  const mobileHeight = productTemplate?.symbolHeight * mobileScale;

  const campaignNameColor =
    CAMPAIGN_COLORS[productTemplate?.campaignNameColor?.toLowerCase()];
  //END SYMBOL FROM PRODUCT TEMPLATE SIZE
  const relatedProducts = get(product, 'relatedProducts');
  //const recommendedProducts = get(product, 'recommendedProducts');
  const outOfStockNotify = stockStatus.status === 'notifyWhenBack';
  const favouriteMargin =
    productTemplate?.symbolPosition === 'Överkant - Höger';
  const saleBadges = [
    ...(product?.badges || []),
    {
      name: 'SaleSpecial',
      url: null,
      location: 'TOP_LEFT',
      style: saleTemplate.tagClass,
      text: saleTemplate.tagText
    }
  ];

  const maxProducts = parseInt(productTemplate?.maxProducts ?? 0) ?? 0;
  const isMax = maxProducts > 0 && alreadyInCart >= maxProducts;
  const calculatedMaxQuantity = () => {
    if (maxProducts - alreadyInCart <= 1) {
      return 1;
    } else {
      return maxProducts - alreadyInCart;
    }
  };
  const artNo_partial = getArtNoPartial(product?.articleNumber);

  const fixedPercentage = getPercentage(
    selectedVariationToUse || productToUse,
    hasMemberPrice
  );

  // Refs to prevent duplicate tracking
  const hasTrackedViewItemRef = useRef(null);
  const hasTrackedPageViewRef = useRef(null);

  // Track product view on page landing (must be before early return)
  // Only track once per product ID - fires immediately when product loads
  // Per documentation: view_item should fire when landing on product page, NOT on variant selection
  useEffect(() => {
    if (product && !loading && hasTrackedViewItemRef.current !== product.id) {
      trackViewItem({
        product: { ...product, parents },
        variant: null // Track without variant - this is the initial page view
      });
      hasTrackedViewItemRef.current = product.id;
    }
  }, [product, parents, loading, trackViewItem]);

  // Track page view - only once per product
  useEffect(() => {
    if (product && !loading && hasTrackedPageViewRef.current !== product.id) {
      trackPageView({
        pageType: PAGE_TYPES.PRODUCT,
        pagePath:
          product.primaryRoute?.path ||
          (typeof window !== 'undefined' ? window.location.pathname : '/'),
        pageTitle:
          product.name ||
          (typeof document !== 'undefined' ? document.title : '')
      });
      hasTrackedPageViewRef.current = product.id;
    }
  }, [product, loading, trackPageView]);

  const handleVariantChange = variant => {
    if (variant?.link?.length > 0) {
      history.push(variant?.link);
    }
  };

  // Return early if there is no cache hit
  if (loading)
    return (
      <>
        <Helmet>
          {shouldSkipGmfCommentSection && (
            <meta name="robots" content="noindex" />
          )}
        </Helmet>
        <ProductContainer>
          <ProductPageLoadingState />
        </ProductContainer>
      </>
    );

  return (
    <>
      <Helmet>
        {shouldSkipGmfCommentSection && (
          <meta name="robots" content="noindex" />
        )}
      </Helmet>

      <ProductContainer>
        <VoyadoTracking
          product={{ ...product, parents: parents }}
          variant={selectedVariation || null}
        />
        <AddToCartForm
          product={product}
          variant={selectedVariation}
          parents={parents}
        >
          {({ ...formProps }) => {
            return (
              <>
                <BreadcrumbsMaxWidth className={breadcrumWrapperStyles}>
                  <Breadcrumbs
                    parents={parents}
                    breadcrumbs={categoryBreadcrumbs}
                    className="product-breadcrumbs"
                  />
                </BreadcrumbsMaxWidth>
                <Container>
                  <ProductMeta {...{ product, selectedVariation }} />

                  <ProductUpper>
                    <ProductLeft>
                      <Above breakpoint="md">
                        {matches =>
                          matches ? (
                            <AddFavourite
                              product={product}
                              style={{
                                float: 'right',
                                marginLeft: 'auto',
                                right: '.5rem',
                                fontSize: '1.5em',
                                marginTop: favouriteMargin
                                  ? `calc(0.5rem + ${desktopSize}px)`
                                  : '0.5rem',
                                zIndex: '2'
                              }}
                            />
                          ) : (
                            <AddFavourite
                              product={product}
                              style={{
                                float: 'right',
                                marginLeft: 'auto',
                                right: '.5rem',
                                fontSize: '1.5em',
                                marginTop: favouriteMargin
                                  ? `calc(0.5rem + ${mobileSize}px)`
                                  : '0.5rem',
                                zIndex: '2'
                              }}
                            />
                          )
                        }
                      </Above>

                      {product?.images && (
                        <ImageContainer
                          images={product.images}
                          badges={
                            isSale && hasSaleTemplate
                              ? saleBadges
                              : product.badges
                          }
                          youtube={getYoutube(product)}
                        >
                          {productTemplate &&
                            productTemplate?.symbol &&
                            !doNotRender && (
                              <ProductSymbolWrapper
                                symbolSize={desktopSize + 'px'}
                                symbolHeight={
                                  hasHeight ? height + 'px' : desktopSize + 'px'
                                }
                                symbolSizeMobile={mobileSize + 'px'}
                                symbolHeightMobile={
                                  hasHeight
                                    ? mobileHeight + 'px'
                                    : mobileSize + 'px'
                                }
                                style={parsePosition(
                                  productTemplate?.symbolPosition
                                )}
                              >
                                <Image
                                  className="product-symbol"
                                  sizes={desktopSize}
                                  aspect={'1:1'}
                                  quality={100}
                                  alt={productTemplate?.symbolText ?? ''}
                                  title={productTemplate?.symbolText ?? ''}
                                  src={
                                    productTemplate?.symbolPDP ??
                                    productTemplate?.symbol
                                  }
                                />
                              </ProductSymbolWrapper>
                            )}
                        </ImageContainer>
                      )}

                      <Above breakpoint="lg">
                        {matches =>
                          matches && (
                            <>
                              <ElevateRecommendationsHandler
                                recommendationsLists={
                                  elevateProductPageData?.recommendationLists
                                }
                              />
                            </>
                          )
                        }
                      </Above>
                    </ProductLeft>
                    <ProductRight>
                      <div className="product-details">
                        <header>
                          <div className="left">
                            <a href="#allReviews">
                              <GmfProductRating productId={artNo_partial} />
                            </a>
                            <Names>
                              <h1
                                data-testid="product-title"
                                className={cx(
                                  'product-title',
                                  pdpProductTitleStyle
                                )}
                              >
                                <span className="brand-name">
                                  {getBrand(product)}
                                </span>
                                <span className="product-name">
                                  {removeBrandFromProductName(product) ||
                                    'Loading...'}
                                </span>
                                <ArticleNumber>
                                  {t('Art. nr')} {product?.articleNumber}
                                </ArticleNumber>
                                <Above breakpoint="lg">
                                  <span className="product-variation">
                                    {product?.subName}
                                  </span>
                                </Above>
                              </h1>
                            </Names>
                          </div>
                          <div className="right">
                            <div>
                              <BrandLink brandLink={getBrand(product)} />
                            </div>
                          </div>
                        </header>

                        <div className="price-row">
                          <Intl>
                            {t => (
                              <PriceWrapper
                                fromText={t('Fr.')}
                                className={
                                  (!selectedVariation ? hasPriceDiffer : null)
                                    ? 'price-range'
                                    : 'single-price'
                                }
                              >
                                <Price
                                  memberPrice={
                                    (selectedVariationToUse || productToUse)
                                      ?.memberPrice
                                  }
                                  loggedIn={loggedIn}
                                  fromPrice={
                                    !selectedVariation && hasPriceDiffer
                                  }
                                  price={
                                    (selectedVariationToUse || productToUse)
                                      ?.price
                                  }
                                  previousPrice={
                                    (selectedVariationToUse || productToUse)
                                      ?.previousPrice
                                  }
                                  style={{
                                    opacity: (
                                      configurationContext
                                        ? configurationContext.loading
                                        : null
                                    )
                                      ? 0.3
                                      : 1
                                  }}
                                  fixedPercentage={fixedPercentage}
                                ></Price>
                              </PriceWrapper>
                            )}
                          </Intl>
                          <PriceHistory
                            product={product}
                            selectedVariation={selectedVariation}
                          />
                        </div>

                        {productTemplate?.symbolText && !doNotRender && (
                          <div
                            className="campaign-name"
                            style={{ color: campaignNameColor }}
                            dangerouslySetInnerHTML={{
                              __html: productTemplate?.campaignName
                            }}
                          />
                        )}

                        <StyledForm>
                          {/* <ProductColors
                            mainProductId={product?.id}
                            productColor={product?.subName}
                            productArtNo={product?.articleNumber}
                            productVariants={product}
                          /> */}
                          {elevateProductPageData?.productGroup?.products && (
                            <ElevateVariants
                              variantProducts={
                                elevateProductPageData?.productGroup?.products
                              }
                              onVariantChange={handleVariantChange}
                              selectedVariantKey={product?.articleNumber}
                              shouldSlice={false}
                              shouldSort={true}
                              showName={true}
                              className={cx(
                                'elevate-variants-product-page',
                                elvateVariantsPDPStyle
                              )}
                            />
                          )}
                          {product.hasVariants && sortedSizesProduct && (
                            <VariantSelector
                              product={sortedSizesProduct}
                              variantHandler={variantHandler}
                              voyadoFavoriteStore={favoriteStore}
                            />
                          )}
                          {product.customerComments &&
                            product.customerComments.map(comment => (
                              <InputWithLabel
                                wrapperClassName="customer-comment-input-wrapper"
                                className="customer-comment-input"
                                data-testid={`${comment?.name}-input`}
                                name={`comments[${comment?.name}]`}
                                label={comment.name}
                                key={comment.name}
                              />
                            ))}

                          {!outOfStockNotify && (
                            <QuantityAddToCartWrapper>
                              <QuantityInput
                                disableValidation
                                wrapperClassName="quantity-input-wrapper"
                                min="1"
                                type="number"
                                name="quantity"
                                label="Quantity"
                                setValues={formProps?.setValues}
                                values={formProps?.values}
                                value={
                                  calculatedMaxQuantity() < maxProducts &&
                                  calculatedMaxQuantity()
                                }
                                disabled={true}
                                maximum={
                                  maxProducts > 0
                                    ? calculatedMaxQuantity()
                                    : 999
                                }
                              />
                              {maxProducts > 0 && (
                                <MaxQtyComment
                                  setValues={formProps?.setValues}
                                  maxQty={maxProducts}
                                  alreadyInCart={alreadyInCart}
                                />
                              )}

                              <BuyButton
                                data-testid="add-to-cart"
                                type="submit"
                                isMax={isMax}
                                onClick={() => {
                                  const elevateProduct =
                                    getElevateProductByKeyFromProductGroup(
                                      elevateProductPageData?.productGroup,
                                      product?.articleNumber
                                    );

                                  if (elevateProduct) {
                                    notification(
                                      NOTIFICATION_TYPES.addToCart,
                                      elevateProduct?.ticket
                                    );
                                  }
                                  setShowCurtain(true);
                                }}
                                className={
                                  (product ? product?.hasVariants : null)
                                    ? selectedVariation
                                      ? !selectedVariation.stockStatus?.buyable
                                        ? 'disabled'
                                        : null
                                      : 'disabled'
                                    : (
                                        product
                                          ? !product?.stockStatus?.buyable
                                          : null
                                      )
                                    ? 'disabled'
                                    : null
                                }
                              >
                                {product.stockStatus.text
                                  .toLowerCase()
                                  .includes('kommer snart') ? (
                                  <>
                                    {t('Comming soon')}
                                    {/* <span>
                                 
                                      {t('In stock')}{' '}
                                       {dayjs(
                                        product.stockStatus.stockDate
                                      ).format('MM/DD')}
                                      
                                    </span> */}
                                  </>
                                ) : product && product?.stockStatus?.buyable ? (
                                  <>{t('Add to cart')}</>
                                ) : (
                                  <>
                                    {product.stockStatus.text
                                      .replace(/\([^)]*\)/, '')
                                      .trim()}
                                  </>
                                )}
                              </BuyButton>
                            </QuantityAddToCartWrapper>
                          )}
                        </StyledForm>
                        {outOfStockNotify && (
                          <NotifyWhenBack
                            text={stockStatus.text}
                            articleNumber={
                              (selectedVariation || product).articleNumber
                            }
                          />
                        )}
                        <StoreDeliveryFlex
                          className={
                            (
                              product?.variants?.options?.length < 1
                                ? colorData?.search?.products?.result
                                    ?.length === 1
                                : null
                            )
                              ? 'double'
                              : 'single'
                          }
                        >
                          {product?.variants?.options?.length < 1 &&
                            colorData?.search?.products?.result?.length ===
                              1 && (
                              <DeliveryInformation className="delivery-information">
                                {product?.stockStatus?.buyable === true ? (
                                  <Checkmark />
                                ) : (
                                  <Cross />
                                )}
                                {product?.stockStatus?.text
                                  .replace(/\([^)]*\)/, '')
                                  .trim()}
                              </DeliveryInformation>
                            )}
                          {!['EU', 'NL'].includes(selectedChannel.name) && (
                            <>
                              <StoreStock
                                product={product}
                                initialIndex={selectedVariation?.articleNumber}
                                voyadoFavoriteStore={favoriteStore}
                              />
                            </>
                          )}
                        </StoreDeliveryFlex>

                        <DynamicCategoryRenderer
                          categoryId={3452}
                          rendererComponents={productPageComponents}
                        />
                        <Below breakpoint="md">
                          {chosenProducts && (
                            <BuyTheStyle products={chosenProducts} />
                          )}
                        </Below>
                        {productTemplate?.campaignDescription &&
                          !doNotRender && (
                            <div
                              className="symbol-description"
                              dangerouslySetInnerHTML={{
                                __html: productTemplate?.campaignDescription
                              }}
                            />
                          )}

                        <div
                          className="gmf-top-review"
                          data-product-id={artNo_partial}
                        ></div>
                        <Below breakpoint="lg">
                          <GmfProductSummary sku={artNo_partial} />
                        </Below>

                        <ProductInfoAccordion
                          warningInfo={getWarningInfo(product)}
                          importantInfoHeadline={getImportantInfoHeadline(
                            product
                          )}
                          importantInfo={getImportantInfo(product)}
                          goodtoknow={getGoodToKnow(product)}
                          material={getMaterial(product)}
                          materialInfo={getMaterialInfo(product)}
                          product={product}
                          artNo_partial={artNo_partial}
                          manufacturer={manufacturer}
                        />
                      </div>
                      <Below breakpoint="lg">
                        {matches =>
                          matches && (
                            <ElevateRecommendationsHandler
                              recommendationsLists={
                                elevateProductPageData?.recommendationLists
                              }
                            />
                          )
                        }
                      </Below>
                      <div
                        style={{ marginTop: '2rem' }}
                        id="gmf-comment-section"
                        data-product-id={artNo_partial}
                      ></div>
                    </ProductRight>
                  </ProductUpper>
                </Container>
                {relatedProducts && (
                  <RelatedProducts
                    products={relatedProducts}
                    loading={loading}
                  />
                )}
              </>
            );
          }}
        </AddToCartForm>
      </ProductContainer>
      <Favorites id={177} title={'Du kanske också gillar'} />
      {showCurtain && (
        <ElevateAddToCartPopup
          isOpen={showCurtain}
          setIsOpen={setShowCurtain}
          addedProductKey={(selectedVariation || product)?.articleNumber}
          hasVariants={product.hasVariants}
        />
      )}
    </>
  );
};

export default Product;
